/**
 * Тексты заглушек для содержимого, которое пока не переносится в документ.
 *
 * Живут на уровне обоих форматов намеренно: заглушка обязана быть одинаковой,
 * иначе один экспорт покажет «[Изображение]», а другой попытается отрисовать
 * картинку — и «одинаковое поведение форматов» станет неправдой.
 */
export const PLACEHOLDER_IMAGE = 'Изображение';
export const PLACEHOLDER_TABLE = '[Таблица]';

/**
 * Класс, которым помечается заглушка-абзац в HTML для pdf.
 *
 * Нужен, чтобы проход красной строки отличил её от прозы: в docx у заглушки отступа нет,
 * и без маркера форматы разошлись бы. Своя метка, а не угадывание по тексту.
 */
export const PLACEHOLDER_CLASS = 'ws-export-placeholder';

/** Подпись для картинки: с описанием, если автор его дал. */
export function imagePlaceholderText(alt: string): string {
  const trimmed = alt.trim();

  return trimmed ? `[${PLACEHOLDER_IMAGE}: ${trimmed}]` : `[${PLACEHOLDER_IMAGE}]`;
}
